import React from 'react';
import { useOutletContext } from 'react-router-dom';
import TransactionMonitor from '../components/TransactionMonitor';
import RIEEfficiency from '../components/RIEEfficiency';
import WalletStatus from '../components/WalletStatus';
import CompliancePanel from '../components/CompliancePanel';
import AgentFeed from '../components/AgentFeed';

const Overview = () => {
  const { data, environment } = useOutletContext();

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Overview</h1>
          <p>
            Live platform health, transaction flow, and compliance posture
            <span className="text-tx3"> · {environment}</span>
          </p>
        </div>
      </div>

      <div className="dashboard-grid stagger">
        <TransactionMonitor
          summary={data.transactions?.summary || {}}
          corridors={data.transactions?.corridors || []}
          timeseries={data.transactions?.timeseries || []}
        />
        <RIEEfficiency
          routes={data.transactions?.routes || []}
          summary={data.transactions?.summary || {}}
        />
        <WalletStatus wallets={data.wallets || []} />
        <CompliancePanel
          summary={data.compliance?.summary || {}}
          flags={data.compliance?.recentFlags || []}
        />
        <AgentFeed reports={data.agentReports || []} />
      </div>
    </>
  );
};

export default Overview;
